// METIS Hub wording — namespace "login" (en), 82 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/login.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const login: Record<string, string> = {
  "login.title": "Sign in",
  "login.sub": "Sign in to see AI usage records",
  "login.id": "User ID",
  "login.idPh": "name@example.com",
  "login.pw": "Password",
  "login.pwPh": "Enter password",
  "login.pwShow": "Show password",
  "login.pwHide": "Hide password",
  "login.caps": "Caps Lock is on",
  "login.submit": "Sign in",
  "login.busy": "Signing in…",
  "login.or": "or",
  "login.google": "Continue with Google",
  "login.googleBusy": "Checking your Google account…",
  "login.googleHint": "Only company-domain (example.com) accounts can sign in.",
  "login.googleOff": "Google sign-in isn’t set up yet. Please contact your admin.",
  "login.noAccount": "No account? Ask your admin for an invitation.",
  "login.forgot": "Forgot your password? Ask your admin to reset it.",
  "login.err.id": "Enter your user ID.",
  "login.err.pw": "Enter your password.",
  "login.err.wrong": "The user ID or password is incorrect · {n|try|tries} left",
  "login.err.lastHint": "One more miss locks sign-in for {min} minutes.",
  "login.err.server": "Sign-in isn’t available right now. Please try again shortly.",
  "login.err.serverCode": "Error AUTH-503 · the sign-in server isn’t responding",
  "login.gerr.domain": "This isn’t a company-domain (example.com) account. Try again with your company Google account.",
  "login.gerr.cancel": "Google sign-in wasn’t completed. Please try again.",
  "login.gerr.unlinked": "This Google account is linked to another user. Please contact your admin.",
  "login.gerr.other": "Google sign-in failed. Please try again shortly.",
  "login.welcome": "Welcome, {name}",
  "login.lock.title": "Sign-in is locked for now",
  "login.lock.desc": "The password was wrong {n} times, so sign-in is locked for {min} minutes. If this wasn’t you, tell your admin.",
  "login.lock.left": "You can try again in {mmss}",
  "login.lock.leftMin": "{n|minute|minutes} left",
  "login.lock.ended": "Sign-in is unlocked. Please sign in again.",
  "login.mfa.kicker": "Multi-factor authentication (MFA)",
  "login.mfa.title": "Enter your verification code",
  "login.mfa.desc": "{name}’s account has admin permissions, so it needs multi-factor authentication. Enter the 6-digit code from your authenticator app.",
  "login.mfa.code": "6-digit code",
  "login.mfa.hint": "The code changes every 30 seconds.",
  "login.mfa.submit": "Verify",
  "login.mfa.err": "Enter 6 digits.",
  "login.mfa.other": "Use another account",
  "login.mfa.help": "Can’t use your authenticator app? Ask your admin to reset it.",
  "login.gate.kicker": "First sign-in · step {i} of {n}",
  "login.gate.stepsLabel": "First sign-in steps",
  "login.gate.s.password": "Change password",
  "login.gate.s.pledge": "Prohibited-use pledge",
  "login.gate.s.mfaSetup": "Set up MFA",
  "login.gate.noClose": "First sign-in steps can’t be skipped. You’ll go Home when they’re done.",
  "login.gate.password.title": "Please change your password",
  "login.gate.password.desc": "You signed in with a temporary password from your admin. Set a new password to continue.",
  "login.gate.pw.new": "New password",
  "login.gate.pw.confirm": "Confirm new password",
  "login.gate.pw.rule.len": "At least 10 characters",
  "login.gate.pw.rule.mix": "At least 3 of: uppercase, lowercase, digits, symbols",
  "login.gate.pw.rule.id": "Doesn’t contain your user ID",
  "login.gate.pw.rule.match": "Both fields match",
  "login.gate.pw.ruleOk": "met",
  "login.gate.pw.ruleNo": "not yet",
  "login.gate.pw.rules": "Password rules",
  "login.gate.pw.submit": "Change password",
  "login.gate.pw.err": "Please meet every rule.",
  "login.gate.pw.done": "Password changed. You were signed out everywhere else.",
  "login.gate.pledge.title": "Prohibited-use pledge",
  "login.gate.pledge.desc": "The {role} role can see other people’s question and answer text or real names. Before you start, pledge not to use them for prohibited purposes.",
  "login.gate.pledge.1": "I won’t use them for HR evaluation, attendance or performance judgments.",
  "login.gate.pledge.2": "I won’t open text outside work purposes such as security incidents, user support or outage investigations.",
  "login.gate.pledge.3": "I won’t copy or export what I see without permission.",
  "login.gate.pledge.4": "I understand that every view needs a reason and is shown to the person.",
  "login.gate.pledge.check": "I have read the above and pledge to follow it",
  "login.gate.pledge.sign": "Signature — type your name exactly ({name})",
  "login.gate.pledge.version": "Pledge v1.0 · you pledge again when your role or the pledge changes · pledges are kept in the access & change log",
  "login.gate.pledge.submit": "Pledge and continue",
  "login.gate.pledge.errCheck": "Please tick the pledge.",
  "login.gate.pledge.errSign": "Type the same name as your account.",
  "login.gate.pledge.done": "Your pledge is recorded.",
  "login.gate.mfaSetup.title": "Set up multi-factor authentication (MFA)",
  "login.gate.mfaSetup.desc": "The {role} role has admin permissions, so MFA is required. Scan the QR code below with your authenticator app, then enter its 6-digit code.",
  "login.gate.mfa.key": "Setup key (mockup sample)",
  "login.gate.mfa.copy": "Copy setup key",
  "login.gate.mfa.submit": "Set up and start",
  "login.gate.mfa.done": "MFA is set up.",
};

export default login;
